/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */
import { CURRENT_CLIENT_TEMPLATE_VAR } from '@core';
import { HttpClient } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import type {
  ActionPointsControllerCreateActionPointPathParameters,
  ActionPointsControllerDeleteActionPointPathParameters,
  ActionPointsControllerGetActionPointsPathParameters,
  ActionPointsControllerGetDeviceActionPointsPathParameters,
  ActionPointsControllerUpdateActionPointPathParameters,
  CreateActionPointDto,
  UpdateActionPointDto,
} from '../models';

@Injectable({ providedIn: 'root' })
export class ActionPointsService {
  private readonly http = inject(HttpClient);
  /**
   * @summary Retrieve all action points available for a client
   */

  getActionPoints<TData = void>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
  }: ActionPointsControllerGetActionPointsPathParameters): Observable<TData> {
    return this.http.get<TData>(`/devices/v1/clients/${clientId}/action-points`);
  }
  /**
   * @summary Create a new action point
   */

  createActionPoint<TData = void>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR }: ActionPointsControllerCreateActionPointPathParameters,
    createActionPointDto: CreateActionPointDto,
  ): Observable<TData> {
    return this.http.post<TData>(`/devices/v1/clients/${clientId}/action-points`, createActionPointDto);
  }
  /**
   * @summary Retrieve all action points available for a device
   */

  getDeviceActionPoints<TData = void>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
    deviceId,
  }: ActionPointsControllerGetDeviceActionPointsPathParameters): Observable<TData> {
    return this.http.get<TData>(`/devices/v1/clients/${clientId}/action-points/device/${deviceId}`);
  }
  /**
   * @summary Update an action point
   */

  updateActionPoint<TData = void>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR, id }: ActionPointsControllerUpdateActionPointPathParameters,
    updateActionPointDto: UpdateActionPointDto,
  ): Observable<TData> {
    return this.http.patch<TData>(`/devices/v1/clients/${clientId}/action-points/${id}`, updateActionPointDto);
  }
  /**
   * @summary Delete an action point
   */

  deleteActionPoint<TData = void>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
    id,
  }: ActionPointsControllerDeleteActionPointPathParameters): Observable<TData> {
    return this.http.delete<TData>(`/devices/v1/clients/${clientId}/action-points/${id}`);
  }
}
